<template>
	<div class="restricted-input">
    <label>{{fieldLabel}}</label>
    <label class="instructions-label">{{instructionsLabel}}</label>
    <label :data-limit="`${charactersUsed}/${limit}`" :class="getColor('primary')" >
    <input
      :class="{ 'restricted-input form-control': true, 'form-control-error': errors.has('primaryInput') }"
      id="primaryInput"
      name="primaryInput"
      type="text"
      :maxlength="primaryInputLimit"
      @focus="enableShowLimit('primary')"
      @blur="disableShowLimit('primary')"
      :placeholder="primaryPlaceholder"
      :disabled="isDisabled"
      v-model="primaryInputMessage"
      v-validate="{required: isFirstInputRequired}" >
    </label>

    <label :data-limit="`${charactersUsed}/${limit}`" :class="getColor('secondary')" >
      <input
        :class="{ 'restricted-input form-control': true, 'form-control-error': errors.has('secondaryInput') }"
        v-if="dual"
        id="secondaryInput"
        name="secondaryInput"
        type="text"
        :maxlength="secondaryInputLimit"
        @focus="enableShowLimit('secondary')"
        @blur="disableShowLimit('secondary')"
        :placeholder="secondaryPlaceholder"
        :disabled="isDisabled"
        v-model="secondaryInputMessage"
        v-validate="{required: isSecondInputRequired}" >
    </label>
    <p class="red-text" v-show="errors.has('primaryInput') || errors.has('secondaryInput')">Required</p>
    <p class="red-text" v-show="charactersUsed === limit && (showLimitOnPrimary || showLimitOnSecondary)">{{errorMessage}}</p>
  </div>
</template>

<script>
export default {
  name: 'RestrictedTwoInputs',
  props: {
    primaryInput: {
      type: String,
      required: true,
      default: '',
    },
    secondaryInput: {
      type: String,
      required: false,
      default: '',
    },
    instructionsLabel: {
      type: String,
      required: false,
      default: '',
    },
    fieldLabel: {
      type: String,
      required: false,
      default: 'label for primary input',
    },
    primaryPlaceholder: {
      type: String,
      required: false,
      default: '',
    },
    secondaryPlaceholder: {
      type: String,
      required: false,
      default: '',
    },
    dual: {
      type: Boolean,
      required: false,
      default: false,
    },
    limit: {
      type: Number,
      required: false,
      default: 50,
    },
    warningLimit: {
      type: Number,
      required: false,
      default: 29,
    },
    isDisabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    isFirstInputRequired: {
      type: Boolean,
      required: false,
      default: false,
    },
    isSecondInputRequired: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      primary: this.primaryInput,
      secondary: this.secondaryInput,
      errorMessage: `You've reached the ${this.limit} character limit`,
      showLimitOnPrimary: false,
      showLimitOnSecondary: false,
    };
  },
  computed: {
    primaryInputMessage: {
      get() {
        return this.primaryInput;
      },
      set(value) {
        this.$emit('inputUpdated', { primary: value, secondary: this.secondaryInputMessage });
      },
    },
    secondaryInputMessage: {
      get() {
        return this.secondaryInput;
      },
      set(value) {
        this.$emit('inputUpdated', { primary: this.primaryInputMessage, secondary: value });
      },
    },
    primaryInputLimit() {
      return this.limit - this.secondaryInputMessage.length;
    },
    secondaryInputLimit() {
      return this.limit - this.primaryInputMessage.length;
    },
    charactersUsed() {
      return this.primaryInputMessage.length + this.secondaryInputMessage.length;
    },
  },
  methods: {
    enableShowLimit(input) {
      input === 'primary' ? this.showLimitOnPrimary = true : this.showLimitOnSecondary = true;  // eslint-disable-line no-unused-expressions
    },
    disableShowLimit(input) {
      input === 'primary' ? this.showLimitOnPrimary = false : this.showLimitOnSecondary = false; // eslint-disable-line no-unused-expressions
    },
    getColor(input) {
      if ((input === 'primary' && !this.showLimitOnPrimary) || (input === 'secondary' && !this.showLimitOnSecondary)) {
        return 'transparent-text';
      }
      if (this.charactersUsed <= this.warningLimit) {
        return 'green-text';
      } else if (this.charactersUsed >= this.warningLimit && this.charactersUsed < this.limit) {
        return 'yellow-text';
      }
      return 'red-text';
    },
  },
};
</script>

<style scoped>

.green-text {
  color: #558C1D;
}

.yellow-text {
  color: #E58A2D;
}

.red-text {
  color: #8C1D1D;
}

.transparent-text {
  color: transparent;
}

.instructions-label {
  color: #797979;
  font-weight: 300;
  margin-bottom: 10px;
}

label, input {
  position: relative;
  display: block;
  box-sizing: border-box;
}

input {
  color: black !important;
  font-weight: normal !important;
  margin-bottom: 15px !important;
}

label::after {
  content: attr(data-limit);
  position: absolute;
  top: 4px;
  right: 5px;
  padding-top: 5px;
  font-size: 12px;
  display: block;
}

</style>



// WEBPACK FOOTER //
// RestrictedTwoInputs.vue?1840a6f9